import { render, staticRenderFns } from "./RFQForm.vue?vue&type=template&id=2ca610cb&"
import script from "./RFQForm.vue?vue&type=script&lang=js&"
export * from "./RFQForm.vue?vue&type=script&lang=js&"
import style0 from "./RFQForm.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports